import { Range, StaticRange } from "react-date-range";
import dayjs from "dayjs";
import { isSameDay } from "date-fns";

export const StaticDateRangeKeys = {
  LAST_DAY: "Last day",
  LAST_7_DAYS: "Last 7 days",
  LAST_28_DAYS: "Last 28 days",
  LAST_30_DAYS: "Last 30 days",
  LAST_3_MONTHS: "Last 3 months",
  LAST_6_MONTHS: "Last 6 months",
  LAST_12_MONTHS: "Last 12 months",
};

const isSelectedRange = (selectedRange: Range, definedRange: Range) => {
  return (
    isSameDay(selectedRange.startDate!, definedRange.startDate!) &&
    isSameDay(selectedRange.endDate!, definedRange.endDate!)
  );
};

export const StaticRanges: Record<string, StaticRange> = {
  [StaticDateRangeKeys.LAST_DAY]: {
    label: "Last day",
    hasCustomRendering: true,
    range: () => ({
      startDate: dayjs().subtract(1, "day").toDate(),
      endDate: dayjs().subtract(1, "day").toDate(),
    }),
    isSelected(range) {
      return isSelectedRange(range, this.range());
    },
  },
  [StaticDateRangeKeys.LAST_7_DAYS]: {
    label: "Last 7 days",
    hasCustomRendering: true,
    range: () => ({
      startDate: dayjs().subtract(7, "day").toDate(),
      endDate: new Date(),
    }),
    isSelected(range) {
      return isSelectedRange(range, this.range());
    },
  },
  [StaticDateRangeKeys.LAST_28_DAYS]: {
    label: "Last 28 days",
    hasCustomRendering: true,
    range: () => ({
      startDate: dayjs().subtract(28, "day").toDate(),
      endDate: new Date(),
    }),
    isSelected(range) {
      return isSelectedRange(range, this.range());
    },
  },
  [StaticDateRangeKeys.LAST_30_DAYS]: {
    label: "Last 30 days",
    hasCustomRendering: true,
    range: () => ({
      startDate: dayjs().subtract(30, "day").toDate(),
      endDate: new Date(),
    }),
    isSelected(range) {
      return isSelectedRange(range, this.range());
    },
  },
  [StaticDateRangeKeys.LAST_3_MONTHS]: {
    label: "Last 3 months",
    hasCustomRendering: true,
    range: () => ({
      startDate: dayjs().subtract(90, "day").toDate(),
      endDate: new Date(),
    }),
    isSelected(range) {
      return isSelectedRange(range, this.range());
    },
  },
  [StaticDateRangeKeys.LAST_6_MONTHS]: {
    label: "Last 6 months",
    hasCustomRendering: true,
    range: () => ({
      startDate: dayjs().subtract(180, "day").toDate(),
      endDate: new Date(),
    }),
    isSelected(range) {
      return isSelectedRange(range, this.range());
    },
  },
  [StaticDateRangeKeys.LAST_12_MONTHS]: {
    label: "Last 12 months",
    hasCustomRendering: true,
    range: () => ({
      startDate: dayjs().subtract(365, "day").toDate(),
      endDate: new Date(),
    }),
    isSelected(range) {
      return isSelectedRange(range, this.range());
    },
  },
};

export const getStaticRanges = (availableStaticRanges: string[]): StaticRange[] => {
  return availableStaticRanges.map(r => StaticRanges[r]);
};
